import FileUpload from './components/FileUpload';

import './App.css';

function App() {
  return (
   <div className="App">
      <FileUpload />
    </div>
  );
}

export default App;

